import { H3, P } from "@/lib/styles";
import styled, { css } from "styled-components";

export const Container = styled.div<{ textPosition?: string }>`
  display: grid;
  grid-template-areas:
    "text"
    "icon";
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-template-areas: ${({ textPosition }) =>
      textPosition === "left" ? `"text icon"` : `"icon text"`};
    grid-template-columns: 1fr 1fr;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-template-areas: ${({ textPosition }) =>
      textPosition === "left" ? `"text icon"` : `"icon text"`};
    grid-template-columns: ${({ textPosition }) =>
      textPosition === "left" ? "2fr 1fr" : "1fr 2fr"};
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    grid-template-areas: ${({ textPosition }) =>
      textPosition === "left" ? `"a text icon b"` : `"a icon text b"`};
    grid-template-columns: ${({ textPosition }) =>
      textPosition === "left" ? "1fr 6fr 4fr 1fr" : "1fr 4fr 6fr 1fr"};
  }
`;

export const Text = styled.div`
  grid-area: text;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2px;
  margin-right: 2px;
  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding-left: 1.5rem;
  }
`;

export const Heading = styled(H3)`
  margin-bottom: 1rem;
  width: fit-content;
`;

export const Excerpt = styled(P)`
  padding: 0.5rem 0;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const IllustrationOuterWrapper = styled.div`
  width: calc(100% * 4 / 6);
  margin-left: auto;
  margin-right: auto;
  ${({ theme }) => theme.mediaQueries.tablet} {
    width: 100%;
    grid-area: icon;
  }
`;

export const IllustrationInnerWrapper = styled.div`
  padding: 1.5rem;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 5rem;
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    padding: 8rem;
  }
`;
